<!-- The script editor's toolbar (#scriptToolbarWrap, z-61): the tools in #tbMain on at most two rows, the rest in the ⋮
     panel (#tbMorePanel, button #tbMoreBtn). The order and the cut come from the toolbar store (layout: at opening, on
     switching back to Visual, when the bar or the window changes size); on phones zoom, font and size go last with
     their separators. Each tool is ToolbarTool.vue (one element, so the layout measures the bar's children). Hidden in
     Markdown and Fountain modes, at once (it follows the editor store's shownMode). -->
<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useI18n } from '../../composables/useI18n'
import { useEditorStore } from '../../stores/editor'
import { useToolbarStore } from '../../stores/toolbar'
import ToolbarTool from './ToolbarTool.vue'

const { t } = useI18n()
const ed = useEditorStore()
const tbs = useToolbarStore()
const wrap = ref<HTMLElement | null>(null)
const main = ref<HTMLElement | null>(null)

watch(() => ed.shownMode, m => { wrap.value?.classList.toggle('hidden', m !== 'visual') }, { flush: 'sync' })

const relayout = () => setTimeout(() => tbs.layout())
const onResize = () => setTimeout(() => tbs.layout(), 50)
let ro: ResizeObserver | null = null
onMounted(() => {
  tbs.setMain(main.value)
  // The observer sees every change of the bar's width (the window's too); without it, the window's resize
  if (window.ResizeObserver && wrap.value) { ro = new ResizeObserver(relayout); ro.observe(wrap.value) }
  else window.addEventListener('resize', onResize)
})
onBeforeUnmount(() => {
  if (ro) ro.disconnect()
  window.removeEventListener('resize', onResize)
  tbs.setMain(null)
})
</script>

<template>
  <div id="scriptToolbarWrap" ref="wrap" class="relative flex items-center gap-1 px-3 py-1.5 border-b border-gray-800 bg-darkcard z-[61]">
    <div id="tbMain" ref="main" class="flex flex-wrap items-center gap-1 flex-1 min-w-0">
      <ToolbarTool v-for="(e, i) in tbs.entries.slice(0, tbs.cut)" :key="'m' + i + e.key" :k="e.key" :lg-hidden="e.lgHidden" />
    </div>
    <button id="tbMoreBtn" type="button" :title="t('More tools')" :class="['tb', { hidden: !tbs.moreBtn, 'text-brand': tbs.more }]" @mousedown.prevent @click="tbs.toggleMore()"><i class="fas fa-ellipsis-vertical"></i></button>
    <div id="tbMorePanel" :class="['absolute right-2 top-full mt-1.5 flex flex-wrap items-center gap-1 p-1.5 bg-darkcard border border-gray-800 rounded-xl shadow-2xl max-w-[min(26rem,calc(100vw-1rem))] modal-animate', { hidden: !tbs.more }]">
      <ToolbarTool v-for="(e, i) in tbs.entries.slice(tbs.cut)" :key="'p' + i + e.key" :k="e.key" :lg-hidden="e.lgHidden" />
    </div>
  </div>
</template>
